// extracted by mini-css-extract-plugin
export default {"tableWrapper":"b527zMU"};